import styled from 'styled-components';

// Shared presentational primitives for the AI-Voice speaker surfaces (the
// Manage modal mapper, the pop-over "AI Voices" tab, and the SpeakerFormModal
// tab bar) so the underline-tab, "Default" badge, and empty-state treatments
// stay identical across surfaces instead of drifting per copy.

// Underline-on-active tab bar. Callers extend it (e.g. styled(TabBar)) for
// layout tweaks like margin/flex-shrink specific to their container.
export const TabBar = styled.div`
  display: flex;
  gap: var(--spacing-lg);
  border-bottom: 1px solid var(--border-subtle);
  flex-shrink: 0;
`;

export const TabButton = styled.button<{ $active: boolean }>`
  position: relative;
  padding: var(--spacing-sm) 0;
  background: none;
  border: none;
  cursor: pointer;
  font-family: var(--font-primary);
  font-size: var(--text-sm);
  font-weight: ${p =>
    p.$active ? 'var(--font-weight-medium)' : 'var(--font-weight-normal)'};
  color: ${p => (p.$active ? 'var(--foreground)' : 'var(--text-secondary)')};
  transition: color var(--transition-fast);

  &:hover {
    color: var(--foreground);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: var(--spacing-2xs);
    border-radius: 1px;
    background-color: ${p => (p.$active ? 'var(--accent)' : 'transparent')};
  }
`;

// "Default" is a status, not an action: a muted note tag beside the name (the
// design system's note-tag pattern), never a green fill.
export const DefaultBadge = styled.span`
  color: var(--text-muted);
  font-size: var(--text-xs);
  font-weight: var(--font-weight-normal);
  white-space: nowrap;
`;

export const EmptyState = styled.div`
  padding: 16px;
  color: var(--text-muted);
  font-size: var(--text-sm);
  border: 1px dashed var(--border);
  border-radius: 8px;
  text-align: center;
`;
